import React, { Component } from 'react';
//### useGoogleLogin(Both implicit & authorization code flow)
import { useGoogleLogin } from '@react-oauth/google';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';

function GoogleLoginButton({ googleResponse, mode = "login" }) {

    //const prompt =
    //    mode === "reconnect"
    //        ? "consent select_account"
    //        : "select_account";
    const prompt =
        mode === "consent select_account";
    const googleOauth = useGoogleLogin({
        onSuccess: codeResponse => googleResponse(codeResponse),
        flow: "auth-code",
        scope: "profile email https://www.googleapis.com/auth/drive.file",
        prompt
    });

    return (
        <button className="btn-sign-in" onClick={googleOauth}>
            <img src="/img/web/1x/btn_google_signin_dark_normal_web.png" />
        </button>
    );
}

 class Login extends Component {
    static displayName = Login.name;

    constructor(props) {
        super(props);
        this.state = { isAuthenticated: false, user: null ,showCookieError:false};
       
    }

    
    onFailure = (error) => {
        console.dir(error);
        if (error.error === "idpiframe_initialization_failed" || "popup_closed_by_user") {
            this.setState({ showCookieError:true })
        }
        //alert(error);

     };

     
    googleResponse = async (response) => {
       
        //const tokenBlob = new Blob([JSON.stringify({ tokenId: response.tokenId }, null, 2)], { type: 'application/json' });
        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...(this.state && this.state.isGoogleReconnect
                    ? { 'X-Google-Reconnect': '1' }
                    : {})
            },

            body: JSON.stringify({ code: response.code }),
            mode: 'cors',
            cache: 'default'
        };


        const fetchData = await fetch('api/auth/google', options);
        console.dir(fetchData);
        let authBody = await fetchData.json();
      
        if (fetchData.status === 200) {
            this.props.getUserInfo();
          
            let path = "";
            try {
            
                path = this.props.location.state.prevpath;
            } catch (e) {
                try {
                    
                    path = this.props.location.pathname;
                } catch (e) {
                    
                    path = "/start";
                }
              
            }
           
            this.props.history.push(path);
            //this.setState({ isAuthenticated: true, user: content.user });
        }
        else if (fetchData.status === 500) {
            console.dir(authBody);
        }
    };
     componentDidMount() {
         const isGoogleReconnect =
             this.props.location &&
             this.props.location.state &&
             this.props.location.state.googleReconnect === true;

         if (isGoogleReconnect) {
             this.setState({ isGoogleReconnect: true });
         }
     }

  
     render() {       
      
  
        const host = window.location.hostname;
        const cookieError = this.state.showCookieError ? <div className="mt-2"> <p>Having login issues? </p> <p className="alert alert-danger">Note: To authenticate in an Incognito browser requires 3rd party cookies enabled in the browser Cookie settings.</p> </div> :"";

        return (
            <div>
                <h1>Welcome to GStitch</h1>
                <p><strong>Google Documents</strong> just got way better.</p>
                <div>
                    <p>Login to get started.</p>
                    <GoogleLoginButton
                        googleResponse={this.googleResponse}
                        mode={this.state.isGoogleReconnect ? "reconnect" : "login"}
                    />


                   
                </div>      
                <div>{cookieError}</div>
            </div>
        );
    }
}
export default withRouter(Login);